import clsx from 'clsx';
import {c, jt, t} from 'ttag';
import {toCurrency} from 'utils/number';

import {
    BillingPlanIntegrationsPriceList,
    BillingPlanOptionsPriceList,
    TermOptions,
} from './types';

export const getTermOptionRadio = (termOptions: TermOptions) =>
    termOptions.map((option) => {
        const twoMonthsFreeSpan = (
            <span
                className={clsx(
                    'rounded px-2 py-0.5 text-xs font-semibold text-white',
                    option.disabled ? 'bg-grey-400' : 'bg-blue-400',
                )}
            >{t`Two Months Free`}</span>
        );
        const TERM_LABELS: Record<string, unknown> = {
            helpText: t`(This plan only supports monthly payment)`,
            monthly: t`Monthly Payment`,
            yearly: t`Yearly Payment`,
            yearlyWithTwoMonthsFree: jt`Yearly Payment ${twoMonthsFreeSpan}`,
        };

        const label = TERM_LABELS[option.i18NKey] as string;
        if (!label) throw new Error(`No label for ${option.i18NKey}`);

        return {
            disabled: option.disabled,
            label,
            value: option.value,
        };
    });

export const getAdditionalOptions = (
    optionPrices: BillingPlanOptionsPriceList,
) => {
    const OPTIONS_LABELS: Record<string, unknown> = {
        customDomain: t`Custom Email Domain`,
        ml4sf: t`MakeLeaps for Salesforce`,
        rakutenVa: c('Billing').t`Virtual Accounts`,
    };

    return optionPrices.map((option) => {
        const label = OPTIONS_LABELS[option.name] as string;

        return {
            label: (
                <div>
                    <span>{label}</span>
                    {option.value && (
                        <span className="text-sm text-grey-500">
                            {' '}
                            {toCurrency({currency: 'JPY', value: option.value})}
                        </span>
                    )}
                </div>
            ),
            name: option.name,
        };
    });
};

export const getIntergrationOptions = (
    integrationsPrices: BillingPlanIntegrationsPriceList,
) => {
    const INTEGRATION_LABELS: Record<string, unknown> = {
        akinaiBugyoIntegration: t`Akinai Bugyo App`,
        customCsvIntegration: t`Custom CSV Import`,
        ipAddressRestriction: t`IP Address Restriction`,
        kanjoBugyoIntegration: t`Kanjo Bugyo App`,
        kintoneIntegration: t`kintone Integration`,
        pcaDxIntegration: t`PCA Kaikei DX App`,
        pdfImporterIntegration: t`PDF Batch Sending`,
        shokonIntegration: t`PCA Shokon DX App`,
        voucherStorageIntegration: t`Electronic Voucher Storage Service Integration`,
    };

    return integrationsPrices.map((option) => {
        const label = INTEGRATION_LABELS[option.name] as string;

        return {
            label: (
                <div>
                    {label}
                    {option.value && (
                        <span className="text-sm text-grey-500">
                            {' '}
                            {toCurrency({currency: 'JPY', value: option.value})}
                        </span>
                    )}
                </div>
            ),
            name: option.name,
        };
    });
};
